<template>
  <div class="pagination">
    <v-pagination
      v-bind="{
        totalVisible: 10,
        ...$props,
        ...$attrs,
      }"
    />
  </div>
</template>

<style scoped lang="less">
.pagination {
  width: calc(100% - 16px);
  height: 64px;
  max-height: 64px;
  position: sticky;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.pagination :deep(.v-pagination) li {
  margin: 0px 4px;
  button {
    box-shadow: none;
    background-color: @white;
    border: 1px solid @stroke-default;
    border-radius: 8px;
    height: 32px;
    width: 32px;
    font-size: 13px;
    min-width: auto;
    font-weight: 500;
  }

  &.v-pagination__prev button,
  &.v-pagination__next button,
  &.v-pagination__item button[disabled] {
    background-color: transparent;
    border: none;
  }
}

.pagination :deep(.v-pagination) li button i {
  font-size: 20px;
}

.pagination :deep(.v-pagination) li.v-pagination__item--is-active button {
  color: @white;
  background-color: @text-brand;
  font-weight: 500;
  min-width: 32px;
  width: auto;
}
</style>
